import {
    ACTION_DELETE_DELETE_SUBCATEGORIES_MARKETPLACE,
    ACTION_POST_CREATE_SUBCATEGORIES_MARKETPLACE,
    ACTION_PUT_UPDATE_SUBCATEGORIES_MARKETPLACE,
    ACTION_DELETE_DELETE_CATEGORIES_MARKETPLACE,
    ACTION_GET_CATEGORIES_BENEFITS_MARKETPLACE,
    ACTION_POST_CREATE_CATEGORIES_MARKETPLACE,
    ACTION_PUT_UPDATE_CATEGORIES_MARKETPLACE,
    ACTION_GET_SUBCATEGORIES_MARKETPLACE,
    ACTION_GET_CATEGORY_TYPE_MARKETPLACE,
    ACTION_GET_CATEGORIES_ID_MARKETPLACE,
    SET_CATEGORIES_BENEFITS_MARKETPLACE,
    ACTION_GET_CATEGORIES_MARKETPLACE,
    SET_CATEGORIES_ID_MARKETPLACE,
    SET_CATEGORY_TYPE_MARKETPLACE,
    SET_SUBCATEGORIES_MARKETPLACE,
    ACTION_GET_MODE_MARKETPLACE,
    SET_CATEGORIES_MARKETPLACE,
    SET_MODO_MARKETPLACE,

} from "@/views/categories_marketplace/store/types/types.js";

import config from "@/views/categories_marketplace/config/category_marketplace_api.js";
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';
import Swal from 'sweetalert2';
import  EventBus  from '@/utils/event_bus.js'; 
import { CategoriesMarketPlaceService } from "../../../services";


const _pathUri = new PathUri(config.port, config.context);

const actions = {

    [ACTION_GET_CATEGORIES_BENEFITS_MARKETPLACE]: async ({ state, commit }, idModo) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/beneficios/modo/`+idModo,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    if (resp.data.payload && Array.isArray(resp.data.payload)) {
                        const categoriesBenefits = resp.data.payload.map((e, i) => ({
                            ...e,
                            activeDialogClient: false,
                            index: i
                        }));
                        
                        commit(SET_CATEGORIES_BENEFITS_MARKETPLACE, categoriesBenefits);
                        resolve(resp.data);
                    } else {
                        console.error("La respuesta no tiene un formato esperado:", resp);
                        reject("La respuesta no tiene un formato esperado");
                    }
                })
                .catch(err => {
                    console.error("Error en la solicitud de beneficios de categorías:", err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error("Error en la solicitud de beneficios de categorías:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_MODE_MARKETPLACE]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/modos/`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    
                    if (resp.data && Array.isArray(resp.data.payload)) {
                        const modos = resp.data.payload.map((e, i) => ({
                            ...e,
                            activeDialogClient: false,
                            index: i
                        }));
                        
                        commit(SET_MODO_MARKETPLACE, modos);
                        resolve(resp.data);
                    } else {
                        console.error("La respuesta no tiene un formato esperado:", resp);
                        reject("La respuesta no tiene un formato esperado");
                    }
                })
                .catch(err => {
                    console.error("Error en la solicitud de modos:", err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error("Error en la solicitud de modos:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_CATEGORIES_MARKETPLACE]: async ({ state, commit }, idModo) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
    
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                CategoriesMarketPlaceService.getCategoriesMarketplace(idGroup,idEmpresa, idUsuario, idModo)
                .then(resp => {
                    if (resp.data.payload && Array.isArray(resp.data.payload)) {
                        const categories = resp.data.payload.map((e, i) => ({
                            ...e,
                            activeDialogClient: false,
                            index: i
                        }));
                        commit(SET_CATEGORIES_MARKETPLACE, categories);
                        resolve(resp.data.payload);
                    } else {
                        console.error("La respuesta no tiene un formato esperado:", resp);
                        reject("La respuesta no tiene un formato esperado");
                    }
                })
                .catch(err => {
                    console.error("Error en la solicitud de categorías:", err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error("Error en la solicitud de categorías:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_CATEGORIES_ID_MARKETPLACE]: async ({ state, commit }, idcategory) => {
        
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/categoria/consult/${idcategory}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    if (resp.data.payload) {
                        const category = resp.data.payload
                        
                        commit(SET_CATEGORIES_ID_MARKETPLACE, category);
                        resolve(resp.data.payload);
                    } else {
                        console.error("La respuesta no tiene un formato esperado:", resp);
                        reject("La respuesta no tiene un formato esperado");
                    }
                })
                .catch(err => {
                    console.error("Error en la solicitud de categorías:", err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error("Error en la solicitud de categorías:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_CATEGORY_TYPE_MARKETPLACE]: async ({ state, commit }, idModo) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/tcategorias/modo/${idModo}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    if (resp.data && Array.isArray(resp.data.payload)) {
                        const typesCategories = resp.data.payload.map((e, i) => ({
                            ...e,
                            activeDialogClient: false,
                            index: i
                        }));
                        commit(SET_CATEGORY_TYPE_MARKETPLACE, typesCategories);
                        resolve(resp.data.payload);
                    } else {
                        console.error("La respuesta no tiene un formato esperado:", resp);
                        reject("La respuesta no tiene un formato esperado");
                    }
                })
                .catch(err => {
                    console.error("Error en la solicitud de tipos de categorías:", err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error("Error en la solicitud de tipos de categorías:", error);
                reject(error);
            }
        });
    },
    
    [ACTION_GET_SUBCATEGORIES_MARKETPLACE]: ({ state, commit }, idCategoria) => {
        return new Promise((resolve, reject) => {
            try {
                commit(SET_SUBCATEGORIES_MARKETPLACE, []);
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/tproductos/categoria/${idCategoria}?_=${Date.now()}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
    
                    if (resp.data.payload) {
                        const subcategories = resp.data.payload.tipoProductos.map((e, i) => ({
                            ...e,
                            nombreCategoria: resp.data.payload.nombreCategoria,
                            activeDialogClient: false,
                            index: i
                        }));
                        commit(SET_SUBCATEGORIES_MARKETPLACE, subcategories);
                        resolve(resp.data.payload);
                    } else {
                        console.error("La respuesta no tiene un formato esperado:", resp);
                        reject("La respuesta no tiene un formato esperado");
                    }
                })
                .catch(error => {
                    console.error("Error en la solicitud de subcategorías:", error);
                    reject(error);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error("Error en la solicitud de subcategorías:", error);
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_CATEGORIES_MARKETPLACE]: ({ state }, category) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
    
                axios.post(
                    `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/categoria/create/`,
                    {
                        nombre: category.nombre,
                        descripcion: category.descripcion,
                        idModo: category.idModo,
                        responsable: category.responsable,
                        correo: category.correo,
                        telefono: category.telefono,
                        idCategoriaBeneficio: category.idCategoriaBeneficio,
                        idTipoCategoriaComercial: category.idTipoCategoriaComercial,
                        idImagenCategoria: category.idImagenCategoria
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'idEmpresa': sessionStorage.getItem("idEmpresa"),
                            'idUsuario': sessionStorage.getItem("idUsuario")
                        }
                    }
                )
                .then(response => {
                    if (response && response.status === 200) {
                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: 'La categoría fue creada exitosamente',
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(response.data);
                    } else {
                        console.error("La petición fue incorrecta o falló");
                        reject("La petición fue incorrecta o falló");
                    }
                })
                .catch(error => {
                    console.error("Error en la solicitud:", error);
                    reject(error);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },    

    [ACTION_PUT_UPDATE_CATEGORIES_MARKETPLACE]: ({ state }, category) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
    
                const requestData = {
                    idCategoriaComercial: category.idCategoriaComercial,
                    nombre: category.nombre,
                    descripcion: category.descripcion,
                    idModo: category.idModo,
                    responsable: category.responsable,
                    correo: category.correo,
                    telefono: category.telefono,
                    idCategoriaBeneficio: category.idCategoriaBeneficio,
                    idTipoCategoriaComercial: category.idTipoCategoriaComercial,
                    idImagenCategoria: category.idImagenCategoria
                }
    
                axios.put(
                    `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/categoria/update/`,
                    requestData,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'idEmpresa': sessionStorage.getItem("idEmpresa"),
                            'idUsuario': sessionStorage.getItem("idUsuario")
                        }
                    }
                )
                .then(resp => {
                    if (resp.data.payload) {
                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: 'La categoría fue actualizada exitosamente',
                            showConfirmButton: false,
                            timer: 2500
                        });
                        EventBus.$emit('reload-update-categoriesMarketplace-sub');
                        resolve(resp.data.payload);
                    } else {
                        reject("La petición fue incorrecta o falló");
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                reject(error);
            }
        });
    },    

    [ACTION_DELETE_DELETE_CATEGORIES_MARKETPLACE]: async ({ state }, idCategory) => {
       
            const resp = await new Promise((resolve, reject) => {
                state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                CategoriesMarketPlaceService.getCategoriesMarketplacedelete(idGroup, idEmpresa, idUsuario,idCategory)
                .then(resp => {

                    EventBus.$emit('reload-delete-marketplace');
                   
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: 'La categoría ha sido eliminada.',
                        showConfirmButton: false,
                        timer: 2500
                    });
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
            });
    
            return resp;
     
    },
    
    [ACTION_POST_CREATE_SUBCATEGORIES_MARKETPLACE]: ({ state }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading_marketplace = true;
    
                axios.post(
                    `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/tproductos/create/`,
                    {
                        nombre: payload.nombre,
                        descripcion: payload.descripcion,
                        categoriaComercial: payload.idCategoriaComercial,
                        modo: payload.modo
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'idEmpresa': sessionStorage.getItem("idEmpresa"),
                            'idUsuario': sessionStorage.getItem("idUsuario")
                        }
                    }
                )
                .then(response => {
                    
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: 'La Subcategoría fue creada exitosamente',
                        showConfirmButton: false,
                        timer: 2500
                    });
                    EventBus.$emit('reload-create-submarketplace');
                    resolve(response.data);
        
                })
                .catch(error => {
                    console.error("Error en la solicitud:", error);
                    reject(error);
                })
                .finally(() => {
                    state.loading_marketplace = false;
                });
            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },    
    
    [ACTION_PUT_UPDATE_SUBCATEGORIES_MARKETPLACE]: ({ state }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading_marketplace = true;
    
                const requestData = {
                    nombre: payload.nombre,
                    descripcion: payload.descripcion,
                    categoriaComercial: payload.categoriaComercial,
                    modo: payload.modo,
                    idTipoProducto: payload.idTipoProducto
                }
    
                axios.put(
                    `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/tproductos/update/`,
                    requestData,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'idEmpresa': sessionStorage.getItem("idEmpresa"),
                            'idUsuario': sessionStorage.getItem("idUsuario")
                        }
                    }
                )
                .then(response => {
                    if (response && response.status === 200) {
                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: 'La Subcategoría fue actualizada exitosamente',
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(response.data);
                    } else {
                        console.error("La petición fue incorrecta o falló");
                        reject("La petición fue incorrecta o falló");
                    }
                })
                .catch(error => {
                    console.error("Error en la solicitud:", error);
                    reject(error);
                })
                .finally(() => {
                    state.loading_marketplace = false;
                });
            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },
    

    [ACTION_DELETE_DELETE_SUBCATEGORIES_MARKETPLACE]: async ({ state }, idSubCategory) => {    
        try {
            const resp = await new Promise((resolve, reject) => {
                state.loading = true;
                axios({
                    method: 'delete',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/tproductos/delete/${idSubCategory}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {

                    EventBus.$emit('reload-delete-submarketplace');

                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: 'La subcategoría ha sido eliminada.',
                        showConfirmButton: false,
                        timer: 2500
                    });
                    
                    resolve(resp);
               
                })
                .catch(err => {
                    reject(err);
                });
            });
    
            return resp;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    
}

export default actions;